/**
 * @generated SignedSource<<5ea6cab5ad3624b1b84fa0ab1eee53a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutoShareToChannelsSetEnabledMutation$variables = {
  streamId: string;
  value: boolean;
};
export type AutoShareToChannelsSetEnabledMutation$data = {
  readonly streamAutoShareSettingsSetEnabled: {
    readonly streamAutoShareSettings: {
      readonly enabled: boolean;
      readonly id: string;
    };
  } | null;
};
export type AutoShareToChannelsSetEnabledMutation$rawResponse = {
  readonly streamAutoShareSettingsSetEnabled: {
    readonly streamAutoShareSettings: {
      readonly enabled: boolean;
      readonly id: string;
    };
  } | null;
};
export type AutoShareToChannelsSetEnabledMutation = {
  rawResponse: AutoShareToChannelsSetEnabledMutation$rawResponse;
  response: AutoShareToChannelsSetEnabledMutation$data;
  variables: AutoShareToChannelsSetEnabledMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "StreamAutoShareSettingsSetEnabled",
    "kind": "LinkedField",
    "name": "streamAutoShareSettingsSetEnabled",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StreamAutoShareSettings",
        "kind": "LinkedField",
        "name": "streamAutoShareSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoShareToChannelsSetEnabledMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutoShareToChannelsSetEnabledMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "157e0253a05ab468d81c4db8843692e7",
    "id": null,
    "metadata": {},
    "name": "AutoShareToChannelsSetEnabledMutation",
    "operationKind": "mutation",
    "text": "mutation AutoShareToChannelsSetEnabledMutation(\n  $streamId: ID!\n  $value: Boolean!\n) {\n  streamAutoShareSettingsSetEnabled(streamId: $streamId, value: $value) {\n    streamAutoShareSettings {\n      id\n      enabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "809c9618526b86bd6e598655c7967b88";

export default node;
